const breadcrumbMiddlewareOnError = store => next => action => {
  const previousState = store.getState()
  const state = store.getState()

  global.rg4js('recordBreadcrumb', `Executing Redux action '${action.type}'`, {
    action
  })
  return next(action)
}

export default breadcrumbMiddlewareOnError
